// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2E5H5","bigColWidth":"Table_bigColWidth__a0-K2","biggerColWidth":"Table_biggerColWidth__3zVBI","row":"Table_row__1Q_zp","col":"Table_col__3trfg"};